import { render } from "./CartList.vue?vue&type=template&id=6bf5b2a8&scoped=true"
import script from "./CartList.vue?vue&type=script&lang=js"
export * from "./CartList.vue?vue&type=script&lang=js"

import "./CartList.vue?vue&type=style&index=0&id=6bf5b2a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf5b2a8"]])

export default __exports__